// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1lx32","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3B8NU"};